import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block" }

import { ArrowLeftIcon } from "@heroicons/vue/24/outline";
import AppButton from "@/components/app/AppButton.vue";
import { useRouter } from "vue-router";
import { computed } from "vue";
import { routes } from "@/constants/";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppButtonBackOrHome',
  setup(__props) {

const router = useRouter();

const canGoBack = computed(() => !!window.history.state.back);

const goBackOrHome = function () {
    canGoBack.value ? router.go(-1) : router.push(routes.home.Home);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppButton, {
    onClick: _withModifiers(goBackOrHome, ["prevent"]),
    color: "transparent",
    class: "!px-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(ArrowLeftIcon), { class: "w-4 h-4 block" }),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(canGoBack) ? "Back" : "Back to Main page"), 1)
    ]),
    _: 1
  }, 8, ["onClick"]))
}
}

})